<template>
  <div>
    <form @submit.prevent="handleOk">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="xl"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Modifier Item
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="2">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('outletCode')}">
                <b-form-input
                  v-model="obj.outletCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="outletCode"
                />
                <small>{{ errors.first('outletCode') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>IsTaxable</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.isTaxable" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>Modifier Group Code</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('modifierGroupCode')}">
                <b-form-input
                  v-model="obj.modifierGroupCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="modifierGroupCode"
                />
                <small>{{ errors.first('modifierGroupCode') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>IsActive</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.isActive" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>Modifier Item Code</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('modifierItemCode')}">
                <b-form-input
                  v-model="obj.modifierItemCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="modifierItemCode"
                />
                <small>{{ errors.first('modifierItemCode') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>IsCD</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.isCD" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>Sequence</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('sequence')}">
                <b-form-input
                  v-model.number="obj.sequence"
                  v-validate="'required|numeric|min_value:0'"
                  type="number"
                  name="sequence"
                />
                <small>{{ errors.first('sequence') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },
  methods: {
    // add and update records
    handleOk(evt) {
      this.$validator.validate().then(valid => {
        if (valid) {
          evt.preventDefault();
          if (this.input === null) {
            this.$store
              .dispatch('CreateModifierItem', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is created'
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.$store
              .dispatch('UpdateModifierItem', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  constants.RECORD_IS_UPDATED
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },
    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          outletCode: '',
          modifierGroupCode: '',
          modifierItemCode: '',
          sequence: 0,
          isTaxable: false,
          isActive: false,
          isCD: false
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
